import {ParentRoute, RouteDefinition} from './types';

export function isParentRoute(route: RouteDefinition): route is ParentRoute {
  return Array.isArray(route.children);
}
